export const setProductMenu = (value, page, limit, count) => {
    return {
      type: 'SET_PRODUCT_MENU',
      payload: { data: value, page, limit, count }
    };
  };